import React, { useState, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import { COLORES } from '../../../../../config/colores'

export default function ConfirmacionPreIngreso ({ cancelPreIngreso, callePreIngreso }) {
  const startTime = () => 15
  const [seconds, setSeconds] = useState(startTime)

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        clearInterval(interval)
        cancelPreIngreso()
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  return (
    <div style={{ overflow: 'hidden' }} >
      <Card className='shadow bg-white rounded card-finalizacion-preingreso'>
        <Card.Body style={{ padding: '0' }}>
          <div style={{ backgroundColor: COLORES.blue.primary, color: '#ffffff', width: '100%', padding: '15px 0', margin: '0' }}>
            <h2 style={{ margin: '0 auto%', color: '#ffffff' }}>Ingreso a calado confirmado por la calle {callePreIngreso}</h2>
          </div>
          <div style={{ textAlign: 'center', margin: '6% auto', width: '80%' }}>
            <h3>Espere las instrucciones del semáforo </h3>
            <h3 style={{ marginTop: '5%' }}>Al finalizar el proceso de calado se le indicará por el display la calle de espera para el egreso</h3>
          </div>
          <h3 style={{ marginTop: '7%' }}>¡Muchas gracias!</h3>
        </Card.Body>
      </Card>
    </div>
  )
}
